import { MultilinkStoryblok } from "~/types/bloks";

const getUrl = (link: { url?: string; cached_url?: string }) =>
  link.url || link.cached_url;

export const getStoryblokUrl = (link: MultilinkStoryblok | undefined) => {
  if (link) {
    const url = getUrl(link);

    if (url) {
      switch (link.linktype) {
        case "story":
          if (url === "/") {
            return "/";
          }

          return `/${url.replace(/\/$/g, "")}${
            link.anchor ? `#${link.anchor}` : ""
          }`;

        case "url":
          return url.replace(/\/$/g, "");

        case "asset":
          return url;
      }
    }
  }

  return undefined;
};
